import { ICertificationOutputDto } from './certification-output-dto.interface';
import { IDeleteOutputDto } from './delete-output-dto.interface';
import { OrderMeasuresTypes } from '../enums';

export interface IOrderLegDto {
    id: string;
    legIndex: number;
    trip?: string;
    checkpointIndex?: number;
    certification?: string | ICertificationOutputDto;
}

export interface IOrderItemProductDto {
    name: string;
    code: string;
}

export interface IOrderItemDto {
    id: string;
    product: IOrderItemProductDto;
    quantity?: number;
    weight?: number;
    subStatus?: string;
}

export interface IOrderMeasureDto {
    type: OrderMeasuresTypes;
    value: number;
}

export interface IOrderOutputDto extends IDeleteOutputDto {
    id: string;
    organizationId: string;
    scheduledDate: string;
    trip: string;
    checkpointIndex: number;
    code: string;
    qtn: string;
    orderItems: IOrderItemDto[];
    orderMeasures: IOrderMeasureDto[];
    certification: string | ICertificationOutputDto;
    secret?: string;
    pinRequired?: boolean;
    createdAt?: string;
    updatedAt?: string;
    legs?: IOrderLegDto[];
}
